export var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus["AVAILABLE"] = "available";
    RecordingStatus["DELETED"] = "deleted";
})(RecordingStatus || (RecordingStatus = {}));
export var AiGenerationStatus;
(function (AiGenerationStatus) {
    AiGenerationStatus["NOT_STARTED"] = "NOT_STARTED";
    AiGenerationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AiGenerationStatus["COMPLETED"] = "COMPLETED";
    AiGenerationStatus["FAILED"] = "FAILED";
})(AiGenerationStatus || (AiGenerationStatus = {}));
export var RecordingRequestType;
(function (RecordingRequestType) {
    RecordingRequestType["LIST"] = "list";
    RecordingRequestType["DETAIL"] = "detail";
    RecordingRequestType["METADATA"] = "metadata";
    RecordingRequestType["BY_CALL_SESSION"] = "byCallSession";
})(RecordingRequestType || (RecordingRequestType = {}));
